/**
 * Site header / primary navigation (2026 redesign)
 * -------------------------------------------------
 * - Sticky bar elevates on scroll (.is-scrolled)
 * - Desktop: hover mega-menus, anchored + clamped inside the 1240 container
 * - Mobile: burger toggles a full-height drawer with accordion sections
 */
(function () {
  'use strict';

  var DESKTOP_MIN = 1200;

  function init() {
    var header = document.getElementById('siteHeader');
    if (!header) return;

    var inner   = header.querySelector('.site-header__inner');
    var bar     = header.querySelector('.site-header__bar');
    var megaItems = Array.prototype.slice.call(header.querySelectorAll('.site-nav__item.has-mega'));
    var plainItems = Array.prototype.slice.call(header.querySelectorAll('.site-nav__item:not(.has-mega)'));
    var burger  = header.querySelector('.site-header__burger');
    var drawer  = header.querySelector('.site-drawer');

    var closeTimer = null;

    // ── Sticky elevation ──────────────────────────────────────────────
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ── Desktop mega menus ────────────────────────────────────────────
    function closeAll() {
      megaItems.forEach(function (li) {
        li.classList.remove('is-active');
        var m = li.querySelector('.site-mega');
        if (m) m.classList.remove('is-open');
      });
    }

    function openItem(li) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      megaItems.forEach(function (other) {
        if (other !== li) {
          other.classList.remove('is-active');
          var m = other.querySelector('.site-mega');
          if (m) m.classList.remove('is-open');
        }
      });
      li.classList.add('is-active');

      var mega = li.querySelector('.site-mega');
      if (!mega) return;
      mega.classList.add('is-open');

      // Anchor under the item, then clamp inside the container gutters.
      var innerRect = inner.getBoundingClientRect();
      var liRect    = li.getBoundingClientRect();
      var pad       = 32;
      var panelW    = mega.offsetWidth;
      var left      = liRect.left - innerRect.left;
      var max       = innerRect.width - panelW - pad;
      left = Math.max(pad, Math.min(left, max));
      mega.style.left = left + 'px';
    }

    megaItems.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (window.innerWidth >= DESKTOP_MIN) openItem(li);
      });
      // Top-level mega links don't navigate.
      var link = li.querySelector('.site-nav__link');
      if (link) {
        link.addEventListener('click', function (e) {
          if (window.innerWidth >= DESKTOP_MIN) e.preventDefault();
        });
      }
    });

    plainItems.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (window.innerWidth >= DESKTOP_MIN) closeAll();
      });
    });

    header.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(closeAll, 160);
    });
    header.addEventListener('mouseenter', function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });

    // ── Mobile drawer ─────────────────────────────────────────────────
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = !header.classList.contains('drawer-open');
        if (open && bar) drawer.style.top = bar.offsetHeight + 'px';
        header.classList.toggle('drawer-open', open);
        document.body.classList.toggle('nav-drawer-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      drawer.querySelectorAll('.site-drawer__acc-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var acc = btn.closest('.site-drawer__acc');
          var isOpen = acc.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    }

    // ── Reset on resize across the breakpoint ─────────────────────────
    window.addEventListener('resize', function () {
      if (window.innerWidth >= DESKTOP_MIN) {
        if (header.classList.contains('drawer-open')) {
          header.classList.remove('drawer-open');
          document.body.classList.remove('nav-drawer-open');
          if (burger) burger.setAttribute('aria-expanded', 'false');
        }
      } else {
        closeAll();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
